module.exports = __webpack_public_path__ + "static/media/logout.18ab9df6.svg";